import XtsBanner from './XtsBanner';
import XtsSection from './XtsSection';

function Xts() {
  return (
    <div>
      <XtsBanner />
      <XtsSection />
    </div>
  );
}

export default Xts;